import { render, staticRenderFns } from "./CreateUpsell.vue?vue&type=template&id=63d2e17c"
import script from "./CreateUpsell.vue?vue&type=script&lang=js"
export * from "./CreateUpsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports